<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('shopTypeManage.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopTypeManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="shopTypeManageInfo.conditions.typeName" :placeholder="$t('shopTypeManage.inputTypeName')"
              clearable />
          </el-form-item>
          <el-form-item>
            <el-select v-model="shopTypeManageInfo.conditions.isShow" :placeholder="$t('shopTypeManage.selectIsShow')"
              style="width:100%">
              <el-option :label="$t('shopTypeManage.yes')" value="Y" />
              <el-option :label="$t('shopTypeManage.no')" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="shopTypeManageInfo.conditions.isDefault"
              :placeholder="$t('shopTypeManage.selectIsDefault')" style="width:100%">
              <el-option :label="$t('shopTypeManage.custom')" value="F" />
              <el-option :label="$t('shopTypeManage.default')" value="T" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="_queryShopTypeMethod">
              {{ $t('shopTypeManage.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('shopTypeManage.shopType') }}</span>
        <el-button type="primary" icon="el-icon-plus" style="float:right" @click="_openAddShopTypeModal">
          {{ $t('shopTypeManage.add') }}
        </el-button>
      </div>
      <div class="card-body">
        <el-table :data="shopTypeManageInfo.shopTypes" border style="width:100%">
          <el-table-column prop="typeName" :label="$t('shopTypeManage.shopType')" align="center" />
          <el-table-column prop="isShow" :label="$t('shopTypeManage.isShow')" align="center">
            <template slot-scope="scope">
              {{ scope.row.isShow === 'Y' ? $t('shopTypeManage.yes') : $t('shopTypeManage.no') }}
            </template>
          </el-table-column>
          <el-table-column prop="isDefault" :label="$t('shopTypeManage.isDefault')" align="center">
            <template slot-scope="scope">
              {{ scope.row.isDefault === 'F' ? $t('shopTypeManage.custom') : $t('shopTypeManage.default') }}
            </template>
          </el-table-column>
          <el-table-column prop="seq" :label="$t('shopTypeManage.seq')" align="center" />
          <el-table-column prop="serviceFee" :label="$t('shopTypeManage.serviceFee')" align="center" />
          <el-table-column prop="remark" :label="$t('shopTypeManage.remark')" align="center" />
          <el-table-column prop="createTime" :label="$t('shopTypeManage.createTime')" align="center" />
          <el-table-column :label="$t('shopTypeManage.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditShopTypeModel(scope.row)">
                {{ $t('shopTypeManage.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteShopTypeModel(scope.row)">
                {{ $t('shopTypeManage.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :current-page="shopTypeManageInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
          :page-size="shopTypeManageInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
          :total="shopTypeManageInfo.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <add-shop-type ref="addShopType" @refresh="_listShopTypes" />
    <edit-shop-type ref="editShopType" @refresh="_listShopTypes" />
    <delete-shop-type ref="deleteShopType" @refresh="_listShopTypes" />
  </div>
</template>

<script>
import { queryShopType } from '@/api/admin/shopTypeApi'
import AddShopType from '@/components/admin/addShopType/addShopType.vue'
import EditShopType from '@/components/admin/editShopType/editShopType.vue'
import DeleteShopType from '@/components/admin/deleteShopType/deleteShopType.vue'

export default {
  name: 'ShopTypeManage',
  components: {
    AddShopType,
    EditShopType,
    DeleteShopType
  },
  data() {
    return {
      shopTypeManageInfo: {
        shopTypes: [],
        total: 0,
        conditions: {
          typeName: '',
          isShow: '',
          isDefault: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listShopTypes()
  },
  methods: {
    async _listShopTypes() {
      try {
        const res = await queryShopType(this.shopTypeManageInfo.conditions)
        this.shopTypeManageInfo.shopTypes = res.data
        this.shopTypeManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _openAddShopTypeModal() {
      this.$refs.addShopType.open()
    },
    _openEditShopTypeModel(row) {
      this.$refs.editShopType.open(row)
    },
    _openDeleteShopTypeModel(row) {
      this.$refs.deleteShopType.open(row)
    },
    _queryShopTypeMethod() {
      this.shopTypeManageInfo.conditions.page = 1
      this._listShopTypes()
    },
    handleSizeChange(val) {
      this.shopTypeManageInfo.conditions.row = val
      this._listShopTypes()
    },
    handleCurrentChange(val) {
      this.shopTypeManageInfo.conditions.page = val
      this._listShopTypes()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>